export default "__VITE_ASSET__7d303427__"